/**
 * SelectedTagsSection Component
 * 
 * Компонент для отображения выбранных тегов в диалоге управления
 * Позволяет удалять теги из выбранных
 */

import React from 'react';
import { TagChip } from './TagChip';
import type { Tag } from '@/integrations/supabase/types';
import { useTranslation } from 'react-i18next';

interface SelectedTagsSectionProps {
  selectedTags: Tag[];
  onRemoveTag: (tagId: string) => void;
}

export const SelectedTagsSection: React.FC<SelectedTagsSectionProps> = ({
  selectedTags,
  onRemoveTag
}) => {
  const { t } = useTranslation();

  if (selectedTags.length === 0) {
    return (
      <div className="border-2 border-dashed border-muted rounded-lg p-6 text-center">
        <p className="text-sm text-muted-foreground">
          {t('records.tag_management.no_selected')}
        </p>
      </div>
    );
  }

  return (
    <div
      data-testid="selected-tags-section"
      className="border border-border rounded-lg p-4 bg-muted/20"
    >
      <div className="flex flex-wrap gap-2">
        {selectedTags.map(tag => (
          <TagChip
            key={tag.id}
            tag={tag}
            size="md"
            onDelete={onRemoveTag}
            className="transition-all hover:scale-105"
          />
        ))}
      </div>

      <div className="mt-3 text-xs text-muted-foreground">
        {t('records.tag_management.selected_count', { count: selectedTags.length })}
      </div>
    </div>
  );
};